'use client';

import { FatalScreen } from '@/lib/components/error/fatal-screen';
import { referenceFor } from '@/lib/components/error/reference-id';
import posthog from 'posthog-js';
import { useEffect } from 'react';

/**
 * Tier 1 - the app itself failed. This sits above the root layout, the theme and every
 * provider, so it renders its own <html>/<body> and delegates to FatalScreen, which owns
 * no design tokens or shared UI.
 *
 * The design's "Sign out" secondary is omitted on purpose: Clerk's provider is one of the
 * things that may have failed, so there is no honest way to offer it. Reload is the only
 * action, and the only one that helps.
 */
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  const referenceId = referenceFor(error);

  useEffect(() => {
    posthog.captureException(error, {
      source: 'global-error',
      digest: error.digest,
      reference_id: referenceId,
    });
  }, [error, referenceId]);

  return (
    <html lang="en">
      <body style={{ margin: 0, minHeight: '100vh', display: 'flex' }}>
        <FatalScreen referenceId={referenceId} />
      </body>
    </html>
  );
}
